module.exports = __webpack_public_path__ + "img/pic23.926bdcd3.png";